const appEl = () => document.getElementById('app');

/** @returns {{ route: string, params: Record<string, string> }} */
export function parseHash() {
  const hash = location.hash.replace(/^#/, '');
  let fallback = '/home';
  try {
    if (!hash && globalThis.localStorage?.getItem('glifo.visited') !== '1') {
      fallback = '/landing';
    }
  } catch {
    fallback = '/home';
  }
  const raw = (hash || fallback).replace(/^\/+/, '');
  const parts = raw.split('/').filter(Boolean);
  const head = parts[0] || 'home';
  const params = {};
  if (head === 'act' && parts[1]) params.act = parts[1];
  if (head === 'level' && parts[1]) params.levelId = decodeURIComponent(parts[1]);
  return { route: head, params };
}

export function navigate(hash) {
  location.hash = hash.startsWith('#') ? hash : `#${hash}`;
}

export function mount(html) {
  const el = appEl();
  if (el) el.innerHTML = html;
}

export async function route() {
  const { route, params } = parseHash();
  const { dispatch } = await import('./dispatch.js');
  await dispatch(route, params, { mount, navigate, parseHash });
}

export function startRouter() {
  window.addEventListener('hashchange', () => route());
  route();
}
